module.exports = __webpack_public_path__ + "static/media/syncspence.4a24942f.png";